"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var Button = (0, system_1.styled)(material_1.Button)(({
    textTransform: 'none',
    // TODO: come back to this while refactoring buttons, pick it up from the theme
    fontWeight: 400,
}));
exports.default = (0, DefaultPropsHoC_1.default)(Button, {
    variant: 'contained',
    color: 'primary',
    type: 'button',
    disableElevation: true,
    disableRipple: true,
});
